export enum GalavailAppStatus {
  INACTIVE,
  ACTIVE
}
